import React, { useState, useCallback, useMemo, useContext } from 'react';
import styled from 'styled-components';
import { SORT_BY_STRING } from '@ubeya/shared/utils/sorting';
import useCRM from '@ubeya/shared/hooks/account/useCRM';
import { ACCOUNT_BILLING_STATUS_MAP } from '@ubeya/shared/constants';
import { ReactComponent as StarIcon } from '@ubeya/shared-web/assets/star-paying-account.svg';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';
import { Tooltip } from '../../Tooltip';

const EmptyOptions = styled.div`
  display: flex;
  justify-content: center;
  height: 50px;
  align-items: center;
`;

const ClientsFilter = ({ defaultValue, handleClose, onApply, search, onChange, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const { clientsOptions } = useCRM();
  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const filteredOptions = useMemo(
    () =>
      (
        (search
          ? clientsOptions.filter(
              ({ label }) =>
                t('clients').toLowerCase().includes(search.toLowerCase()) ||
                t('restrictedClient').toLowerCase().includes(search.toLowerCase()) ||
                label.toLowerCase().includes(search.toLowerCase())
            )
          : clientsOptions) || []
      ).sort(SORT_BY_STRING('label')),
    [clientsOptions, search, t]
  );

  return (
    <FilterLayout name={t('clients')} handleClose={handleClose} onApply={() => onApply(values)} hideLayout={hideLayout}>
      {filteredOptions && filteredOptions?.length > 0 ? (
        filteredOptions.map(({ value, status, label }) => (
          <DropDown.Item key={value}>
            <CheckBox
              name={`client-${value}`}
              value={values.includes(value)}
              label={label}
              onChange={() => handleChange(value)}
            />
            {[ACCOUNT_BILLING_STATUS_MAP.INTERNAL, ACCOUNT_BILLING_STATUS_MAP.PAYING].includes(status) && (
              <Tooltip body={t('supplierEasyAccess')}>
                <StarIcon />
              </Tooltip>
            )}
          </DropDown.Item>
        ))
      ) : (
        <EmptyOptions>{t('noOptions')}</EmptyOptions>
      )}
    </FilterLayout>
  );
};

export default ClientsFilter;
